import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button } from 'semantic-ui-react';
import { IFttbHour } from '../../../app/models/fttbhour';
import FttbHourStore from '../../../app/stores/fttbhourStore';
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';

interface DetailParams {
  id: string;
}

const FttbHourEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history
}) => {
  const fttbhourStore = useContext(FttbHourStore);
  const {
   
    editFttbHour,
    submitting,
    loadFttbHour,
    clearFttbHour,
  } = fttbhourStore;

  const [fttbhour, setFttbHour] = useState<IFttbHour>({
    id: '',
    createdAt: '',
    updatedAt: '',
    financialYear: '',
    payRun: '',
    date: '',
    orderNumber: '',
    hours: 0,
    code: '',
    tech: '',
    note: ''
  });
  

   
  useEffect(() => {
    loadFttbHour(match.params.id)
    .then(fttbhour => {
      setFttbHour(fttbhour);}
    );

    return () => {
      clearFttbHour()
    }
  }, [loadFttbHour]);
  

  const handleSubmit = () => { 
     editFttbHour(fttbhour).then(() => history.push(`/financemanagement/fttbhour`));
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setFttbHour({ ...fttbhour, [name]: value });
  };


  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
      <Form.Input
          label='Financial Year'
          onChange={handleInputChange}
          name='financialYear'
          placeholder='Financial Year'
          value={fttbhour.financialYear}
        />
        <Form.Input
          label='Pay Run'
          onChange={handleInputChange}
          name='payRun'
          placeholder='Pay Run'
          value={fttbhour.payRun}
        />
        <Form.Input
          label='Date'
          onChange={handleInputChange}
          name='date'
          type='date'
          placeholder='Date'
          value={fttbhour.date}
        />
        <Form.Input
          label='Order No.'
          onChange={handleInputChange}
          name='orderNumber'
          placeholder='Order No.'
          value={fttbhour.orderNumber}
        />
        <Form.Input
          label='Hours'
          onChange={handleInputChange}
          name='hours'
          placeholder='Hours'
          value={fttbhour.hours}
        />
        <Form.Input
          label='Code'
          onChange={handleInputChange}
          name='code'
          placeholder='Code'
          value={fttbhour.code}
        />
        <Form.Input
          label='Tech'
          onChange={handleInputChange}
          name='tech'
          placeholder='Tech'
          value={fttbhour.tech}
        />
        <Form.Input
          label='Note'
          onChange={handleInputChange}
          name='note'
          placeholder='Note'
          value={fttbhour.note}
        />
        <Button
          loading={submitting}
          floated='right'
          positive
          type='submit'
          content='Submit'
        />
        <Button
          onClick={() => history.push('/financemanagement/fttbhour')}
          floated='right'
          type='button'
          content='Cancel'
        />
      </Form>
    </Segment>
  );
};

export default observer(FttbHourEditForm);
